module.exports = __webpack_public_path__ + "static/media/renDOGE-ETH.7bf389f1.png";